export default "<div id=\"{{this.chartID}}\"></div>\n"